// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ../~/@master/webinfra-frontend-components/src/components/SaveButton/SaveButton.less
// module id = 1033
// module chunks = 0